$mol_list $mol_view
	render_visible_only true
	render_over 0.1
	sub <= rows /$mol_view
		<= Gap_before $mol_view style * paddingTop <= gap_before 0
		<= Empty $mol_view
		<= Gap_after $mol_view style * paddingTop <= gap_after 0
	item_height_min* 1
	item_width_min* 1
	view_window_shift? 0
	view_window /
		0
		0
